import React from "react";
import { useState } from "react";
export const RoomContext = React.createContext();

const RoomProvider = props => {
    const [roomState, setRoomState] = useState(null);
    const [roomData, setRoomData] = useState({ guests: [] });

    const roomValue = { state: [roomState, setRoomState], data: [roomData, setRoomData] };
    return <RoomContext.Provider value={roomValue}>{props.children}</RoomContext.Provider>
}
export default RoomProvider